module.exports = __webpack_public_path__ + "018c0f6914402e743871ec98bd4d1195.pdf";